/*
 * @Author: Dong
 * @Date: 2022-04-29 13:39:42
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-01 17:32:35
 */
import React, { useEffect } from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { Form, Input } from 'sup-ui';
import styles from './Form.less';
import messages from './messages';
import { reducerStates } from 'root/store/types';
import { useSelector } from 'react-redux';

interface propsType {
  name: string;
  dataSource: { name: string; label: MessageDescriptor; type: any; rules?: any[]; placeholder?: string }[];
  form: any;
}

const formItemLayout = {
  labelCol: {
    sm: { span: 8 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormComponent = (props: propsType) => {
  const { form, name, dataSource } = props;
  const { getFieldDecorator } = form;
  const intl = useIntl();
  const { formData } = useSelector((state: reducerStates) => state.fileConfig);

  // 收集上传列表中的个性化表单配置
  useEffect(() => {
    if (!window.moduleForms) {
      window.moduleForms = {};
    }
    window.moduleForms[name] = form;
    return () => {
      delete window.moduleForms[name];
    };
  }, []);

  return (
    <div>
      <span className={styles.text}>{intl.formatMessage(messages.config)}</span>
      <span className={styles.line} />
      <Form className={styles.form} {...formItemLayout}>
        {dataSource.map((item) => {
          const rules: any[] = item.rules
            ? item.rules.map((rule) => {
                return { ...rule, message: rule.message };
              })
            : [];
          const { placeholder } = item;
          return (
            <Form.Item key={item.name} label={item.label}>
              {getFieldDecorator(item.name, {
                initialValue: formData?.[name]?.[item.name],
                rules: rules,
              })(<Input size="small" placeholder={placeholder} />)}
            </Form.Item>
          );
        })}
      </Form>
    </div>
  );
};

export default Form.create()(FormComponent);
